module.exports = __webpack_public_path__ + "assets/img/23_126.88757ea3.jpg";